"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDate = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Content = require("@quixeltools/quixel-ui-library/dist/components/common/blog/Content");

var _Content2 = _interopRequireDefault(_Content);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _components = require("components");

var _glamor = require("glamor");

var _ramda = require("ramda");

var R = _interopRequireWildcard(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _news = require("redux/modules/news");

var _softwares = require("redux/modules/softwares");

var _utils = require("utils");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _utils2 = require("../../utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString("en-us", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};

var _container = (0, _glamor.css)({
  flexWrap: "wrap",
  width: "100%",
  margin: "auto",
  justifyContent: "center",
  boxSizing: "border-box",
  textAlign: "center"
});
var smallHeading = (0, _glamor.css)(_fonts.superH2, {
  display: "flex",
  justifyContent: "center",
  textTransform: "uppercase",
  margin: "auto",
  paddingTop: "0.5rem",
  //paddingTop: '9rem',
  marginBottom: "2.125rem",
  //color: 'gray',
  textAlign: "center",
  color: _css.pallets.gray_text
});
var _heading = (0, _glamor.css)(_fonts.H2, {
  textTransform: "uppercase",
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  marginBottom: "5.87rem",
  textAlign: "center",
  height: "auto",
  marginTop: "5.87",
  color: "#ffffff"
});

var blogContent = (0, _glamor.css)((0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  flexBasis: "calc(33.33% - 10px)"
}));

var spinnerStyles = (0, _glamor.css)({
  width: "100%",
  height: "400px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& span": {
    width: "40px",
    height: "40px",
    border: "2px solid transparent",
    borderLeftColor: "gray"
  }
});

var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var Home = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Home, _React$Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.state = {
      platform: "Windows",
      variation: ""
    };
    _this.renderContactUsForm = _this.renderContactUsForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({
        platform: platform
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.loaded === false && nextProps.loaded === true || this.props.news !== nextProps.news || this.state.platform !== nextState.platform || this.props.loggedIn !== nextState.loggedIn) {
        return true;
      }

      return false;
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: R.propOr("", "name", initialValues),
          email: R.propOr("", "email", initialValues),
          subject: R.propOr("", "subject", initialValues),
          comment: R.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          news = _props.news,
          user = _props.user,
          isEolConfigLoading = _props.isEolConfigLoading,
          eolConfig = _props.eolConfig;

      var blogPosts = news.blog.slice(0, 3);

      if (isEolConfigLoading) {
        return _react2.default.createElement(
          "div",
          { className: spinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| 3D world-building made easy",
          documentImage: cloudfrontThumbs("page-thumb-quixel.jpg"),
          documentDescription: "Build detailed 3D worlds with 16,000+ high-quality 3D assets, a 3D content manager, and an easy-to-use texturing tool. All free for use with Unreal Engine." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            className: (0, _glamor.css)({ "& h3": { textTransform: "uppercase" } }),
            bg: cf_utils.cf_qx_page("home", "black.jpeg"),
            opacity: 0.25,
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("home", "black.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("home", eolConfig.website.heroBanner.videoFile)
            },
            title: eolConfig.website.heroBanner.title,
            primaryLabel: "",
            primaryTo: "",
            linkIcon: "rightSide",
            secondaryLabel: eolConfig.website.heroBanner.buttonText,
            secondaryTo: eolConfig.website.heroBanner.buttonUrl,
            onScrollDisable: true,
            artist: "",
            link: eolConfig.website.heroBanner.link ? {
              label: eolConfig.website.heroBanner.link.label,
              href: eolConfig.website.heroBanner.link.href,
              target: "_blank",
              rel: "noreferrer"
            } : undefined
          }),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: "MEGASCANS",
            headingBeforeBreak: "#1 CHOICE FOR GAMES, VFX,",
            headingAfterBreak: "ARCHVIZ, AND BEYOND",
            columns: [{
              img: cf_utils.cf_icons("world_class_capture.svg"),
              isIcon: false,
              title: "World-class capture",
              desc: "All 2D and 3D assets are scanned from real-world objects using purpose-built hardware and meticulously processed for the highest-fidelity results."
            }, {
              img: cf_utils.cf_icons("instant_quality.svg"),
              isIcon: false,
              title: "Premium quality",
              desc: "The world’s top AAA and VFX studios rely on the incredible depth and quality of the Megascans library, so they can focus on creativity."
            }, {
              img: cf_utils.cf_icons("industry_standard.svg"),
              isIcon: false,
              title: "Fully standardized",
              desc: "The boring stuff is done for you: Megascans come with optimized topology; UVs and LODs; consistent scale and resolution; and real-world PBR."
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            newHome: true,
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "1_3D_Assets.jpg"),
            images: [cf_utils.cf_qx_page("megascans", "1_3D_Assets.jpg"), cf_utils.cf_qx_page("megascans", "2_Surfaces.jpg"), cf_utils.cf_qx_page("megascans", "3_Vegetation.jpg"), cf_utils.cf_qx_page("megascans", "4_Imperfections.jpg"), cf_utils.cf_qx_page("megascans", "5_Atlases.jpg"), cf_utils.cf_qx_page("megascans", "6_Decals.jpg")],
            title: "Industry-leading excellence",
            desc: "Thousands of high-quality 3D assets, tileable surfaces, vegetation, imperfections, atlases, decals, and more, all at your fingertips. With a library that's constantly updated, you'll always have access to the assets you need to bring your projects to life - fast. Focus on what matters most: your creativity."
          }),
          _react2.default.createElement(_components.Feature, {
            flip: true,
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "go_beyond_photorealism_UE5.jpeg"),
            title: "Go beyond photorealism",
            newHome: true,
            desc: "Years of research, innovation, and engineering have gone into creating Megascans, combining cutting-edge scanning hardware and processing software to achieve unparalleled photorealism. Instantly get rid of the  plastic look of low-quality 3D scans, and push yourself far beyond just photorealism.",
            artist: "Josef Bsharah"
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "megascans-no-more-guesswork.jpg"),
            title: "Skip guesswork",
            newHome: true,
            desc: "Megascans is the definitive standardized content resource. All assets are consistently scanned, scaled and PBR calibrated, and every single 3D mesh comes with meticulously optimized topology, UVs and LODs, meaning you can spend less time doing boring work, and more time having fun creating expansive worlds."
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("4a-games-background.jpg"),
              icon: cf_utils.cf_testimonials("icon/4a-games.png"),
              title: "\u201CCreating an open world with the fidelity of a handcrafted experience requires a staggering amount of high quality assets. It was an incredibly difficult journey for us on Metro Exodus, and Megascans provided significant aid with their bottomless library of high-quality content.\u201D",
              subTitle: "\u2014 Sergei Karmalsky, Art Director, 4A Games",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("dice-test.jpg"),
              icon: cf_utils.cf_testimonials("icon/dice.png"),
              title: "\u201CMegascans is the one and only proper library for high quality scans on the market. Megascans was used throughout Battlefield V to bring in extra quality, flesh out environments, and lift the visual fidelity overall.\u201D",
              subTitle: "\u2014 Pontus Ryman, Senior Environment Artist, EA DICE",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("shadow-of-tomb-raider.jpg"),
              icon: cf_utils.cf_testimonials("icon/cdem.png"),
              title: "\u201CEidos-Montr\xE9al and Crystal Dynamics are proud to have used Quixel Megascans for Shadow of the Tomb Raider in order to help bring to life our meticulously crafted world.\u201D",
              subTitle: "\u2014 Eidos-Montr\xE9al & Crystal Dynamics",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("jungle-book.jpg"),
              icon: cf_utils.cf_testimonials("icon/technicolor.png"),
              title: "\u201CMegascans has become an indispensable resource when building photorealistic environments.\u201D",
              subTitle: "\u2014 Damien Fagnou, SVP, Technicolor",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("the-boundary.jpg"),
              icon: cf_utils.cf_testimonials("icon/boundary.png"),
              title: "\u201CMegascans has long been our go-to resource for all environment needs and has now become an invaluable tool across all types of projects at The Boundary.\u201D",
              subTitle: "\u2014 Henry Goss RIBA / Director, The Boundary",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("capcom-bg.jpg"),
              icon: cf_utils.cf_testimonials("icon/capcom-logo.png"),
              title: "\u201CThanks to Megascans, we were able to visualize the game\u2019s diverse locations and realize the frightening yet beautiful Village we set out to create.\u201D",
              subTitle: "\u2014 Junpei Mashiba, Lead Environment Artist, Capcom",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("ronen-house.jpg"),
              icon: cf_utils.cf_testimonials("icon/craft.png"),
              title: "\u201CWhen it comes to achieving photorealism without compromising performance, Megascans hits all fronts\u2014with a PBR approach, drag-n-drop workflow, and ever-growing library.\u201D",
              subTitle: "\u2014 Ronen Bekerman, Co-Founder, The Craft",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("destiny-2.jpg"),
              icon: cf_utils.cf_testimonials("icon/bungie.png"),
              title: "\u201CMegascans provides the highest quality source material with intuitive tools to combine, permute and create unique new content.\u201D",
              subTitle: "\u2014 Tom Burlington, Technical Art Director, Bungie",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("book-of-the-dead.jpg"),
              icon: cf_utils.cf_testimonials("icon/unity.png"),
              title: "\u201CMegascans empowers even small teams like ours to achieve the quality and realism traditionally exclusive to large AAA productions.\u201D",
              subTitle: "\u2014 Veselin Efremov, Creative Director, Unity Demo Team",
              hr: true
            })
          ),
          _react2.default.createElement(_Section2.default, {
            content: _react2.default.createElement(
              "div",
              { className: _container },
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "div",
                  { className: smallHeading },
                  "QUIXEL BLOG"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _heading },
                "The latest news and articles"
              ),
              _react2.default.createElement(_Content2.default, {
                className: blogContent,
                loaded: this.props.loaded,
                news: blogPosts,
                count: 3,
                isHome: true
              })
            )
          }),
          _react2.default.createElement(
            "div",
            {
              className: (0, _glamor.css)({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2rem"
              }) },
            _react2.default.createElement(_components.TextButtonLibrary, {
              className: (0, _glamor.css)(_fonts.p3, {
                "& a": {
                  letterSpacing: "1px"
                }
              }),
              mode: "normal-small",
              to: "/blog",
              label: "GO TO BLOG"
            })
          ),
          _react2.default.createElement(
            "div",
            {
              className: (0, _glamor.css)({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4rem 2rem 6rem"
              }) },
            _react2.default.createElement(_Button2.default, {
              mode: "secondary",
              label: "Explore Megascans on FAB",
              href: _config2.default.quixelOnFabURL,
              target: "_blank"
            })
          )
        )
      );
    }
  }]);
  return Home;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    var studio = dispatch((0, _softwares.loadMixerUpdater)());
    var news = dispatch((0, _news.loadNews)(1, 6));
    return _bluebird2.default.all([studio, news]);
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    isEolConfigLoading: state.eol.isLoading,
    eolConfig: state.eol.eolConfig || {
      website: {
        heroBanner: {
          title: "Fab Launches in October;</br>Publishing Portal Opens Today",
          videoFile: "fab-assets-logo-looped-webcompressed.mp4",
          buttonText: "Read More",
          buttonUrl: "/blog/2023/3/22/announcing-a-new-chapter-for-quixel"
        }
      }
    },
    news: state.news,
    loaded: state.news.loaded,
    loggedIn: state.auth.loggedIn,
    softwares: state.softwares,
    variation: state.softwares.variation,
    subscription: state.user && state.user.subscription,
    user: state.user
  };
})(Home));


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Home.jsx
// module id = 1254
// module chunks = 0